const windowLocationPathname = window.location.pathname;
const landCode = windowLocationPathname.split('/')[1];
const countryCode = windowLocationPathname.split('/')[2];

const translatedText = {
  en: 'View All',
  ja: '全てみる',
  ko: '모두 보기',
  'zh-cn': '查看全部',
  'zh-tw': '查看全部',
  de: 'Alle anzeigen',
  fr: 'Afficher tout',
  th: 'ดูทั้งหมด',
  id: 'Lihat Semua',
  'zh-hk': '檢視全部',
  vi: 'Xem tất cả',
};

export default class ViewAll {
  /**
   * 「全てみる」ボタンの翻訳テキストを返します。
   * @example
   * import Close from '../lib/ViewAll';
   * ViewAll.text(); => '全てみる'
   */
  static text() {
    const isZh = landCode === 'zh';
    const viewAllText = !isZh
      ? translatedText[landCode]
      : translatedText[`${landCode}-${countryCode}`];
    return viewAllText;
  }
}
